import { AnchorHTMLAttributes, FC, PropsWithChildren } from 'react'

import { ButtonHeight, ButtonMinWidth, ButtonThemeType } from '../types'
import { ButtonLinkStyled } from './ButtonLink.styled'


export interface ButtonLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  buttonTheme?: ButtonThemeType
  buttonHeight?: ButtonHeight
  minWidth?: ButtonMinWidth
}

export const ButtonLink: FC<PropsWithChildren<ButtonLinkProps>> = ({
  children,
  buttonHeight = 'medium',
  buttonTheme = 'blue',
  minWidth,
  ...buttonProps
}) => {
  return (
    <ButtonLinkStyled buttonTheme={buttonTheme} buttonHeight={buttonHeight} minWidth={minWidth} {...buttonProps}>
      {children}
    </ButtonLinkStyled>
  )
}
